<div class="container-fluid box d-flex flex-column pb-3 pt-2 full-size">
  <div *ngIf="isLoading">
    <div class="progress">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
        style="width: {{loadProgress}}%"></div>
    </div>
  </div>

  <div *ngIf="!isLoading" class="full-size">
    <ng-container *ngIf="viewComponent === 'object'">
      <object data="{{currentFile}}" type="application/{{currentFormat}}">
        <embed src="{{currentFile}}" type="application/{{currentFormat}}" />
      </object>
    </ng-container>
    <ng-container *ngIf="viewComponent === 'markdown'">
      <app-markdown-view [content]="fileContent"></app-markdown-view>
    </ng-container>
    <ng-container *ngIf="viewComponent === 'raw'">
      <textarea class="full-size bg-{{theme.bright}} text-{{theme.brightContrast}}" [value]="fileContent" readonly></textarea>
    </ng-container>
  </div>
</div>